import { FormControl, FormHelperText, Input, InputLabel, InputProps } from '@mui/material';
import { JSX } from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { thousandSeparator } from '../dataGrid/dataGridEditNumberCell';

interface NumberTextFieldProps extends Omit<NumericFormatProps<InputProps>, 'onChange'> {
  onChange?: (value: number | undefined) => void;
  label: string;
  error?: boolean;
  helperText?: string;
}

/**
 * A text field for entering number.
 */
const NumberTextField = ({
  label,
  error,
  value,
  helperText,
  onChange,
  ...props
}: NumberTextFieldProps): JSX.Element => (
  <FormControl
    fullWidth
    error={error}
    sx={{
      '& .MuiInput-root': {
        marginTop: '24px',
        borderRadius: '4px',
        overflow: 'hidden',
      },
      '& .Mui-error.MuiInput-root': {
        borderColor: 'error.main',
      },
    }}
  >
    <InputLabel shrink>{label}</InputLabel>
    <NumericFormat
      {...props}
      customInput={Input}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      value={value as any}
      thousandSeparator={thousandSeparator}
      onValueChange={(v): void => {
        onChange?.(v.floatValue);
      }}
    />
    <FormHelperText>{helperText}</FormHelperText>
  </FormControl>
);

export default NumberTextField;
